import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheLongevityFrontier from "./sections/TheLongevityFrontier";
import QueEsUnAlquimico from "./sections/QueEsUnAlquimico";
import Services from "./sections/Services";
import TheNeighborlyAdvantage from "./sections/TheNeighborlyAdvantage";
import WhatYourNeighborsSay from "./sections/WhatYourNeighborsSay";
import StartYourRitual from "./sections/StartYourRitual";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheLongevityFrontier />
      <QueEsUnAlquimico />
      <Services />
      <TheNeighborlyAdvantage />
      <WhatYourNeighborsSay />
      <StartYourRitual />
      <Footer />
    </div>;
}